import { useEffect, useState } from "react";
import type { ReadingPreview } from "@calega/content";
import { api } from "../lib/api";

export function useReadingPreview(input: { contentPageId?: string; adaptiveAssignmentId?: string; individualAssignmentId?: string; settings: unknown }, subject: string, active: boolean) {
  const key = JSON.stringify({ input, subject });
  const [state, setState] = useState<{ key: string; preview?: ReadingPreview; error?: string }>({ key: "" });
  useEffect(() => {
    if (!active) return;
    let cancelled = false;
    setState({ key });
    const timer = window.setTimeout(() => {
      void api<ReadingPreview>("/learning/reading-preview", { method: "POST", body: JSON.stringify(input) }).then((preview) => {
        if (!cancelled) setState({ key, preview });
      }).catch((cause: unknown) => { if (!cancelled) setState({ key, error: cause instanceof Error ? cause.message : "Die Materialvorschau konnte nicht geladen werden." }); });
    }, 150);
    return () => { cancelled = true; window.clearTimeout(timer); };
  }, [key, active]);
  return state.key === key && active ? state : { key };
}

export function ReadingPreviewNotice({ preview, error }: { preview?: ReadingPreview; error?: string }) {
  if (error) return <p className="alert error" role="alert">{error}</p>;
  if (!preview) return <p className="muted" role="status">Verfügbares Material wird geprüft …</p>;
  return <div className={preview.eligible === 0 ? "alert error" : "callout info"} aria-live="polite">
    <p>{preview.eligible} {preview.eligible === 1 ? "passender Eintrag" : "passende Einträge"}{preview.enabled ? ` von ${preview.total} · Buchstaben-/Lautprofil aktiv` : ""}.</p>
    {preview.eligible === 0 && <p>Für diese Auswahl ist kein Material freigegeben. Passe die Übungsauswahl oder das Buchstaben-/Lautprofil an.</p>}
    {preview.eligible === 1 && <p>Dieser Durchlauf endet nach einem Eintrag.</p>}
    {!!preview.excluded?.length && <details><summary>Beispiele ausgeschlossener Einträge</summary><ul>{preview.excluded.map(({ text, reason }, index) => <li key={index}><strong>{text}:</strong> {reason}</li>)}</ul></details>}
  </div>;
}
